import { render, staticRenderFns } from "./seeSchoolShortDialog.vue?vue&type=template&id=7a979619&scoped=true&"
import script from "./seeSchoolShortDialog.vue?vue&type=script&lang=js&"
export * from "./seeSchoolShortDialog.vue?vue&type=script&lang=js&"
import style0 from "./seeSchoolShortDialog.vue?vue&type=style&index=0&id=7a979619&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a979619",
  null
  
)

export default component.exports